import { Size } from '../types/size';
import { ZoomConfig } from '../enums/zoom-config';

export const imageSize: Size = {
  w: 3126,
  h: 2000,
  groundSize: 25,
};

export const tileSize = 25;

export const zoomConfig: { [key: string]: ZoomConfig } = {
  zoomIn: {
    duration: 100,
    zoomUnit: 0.2,
    isZoomIn: true,
  },
  zoomOut: {
    duration: 100,
    zoomUnit: 0.2,
  },
  zoomInIncessantly: {
    duration: 15,
    zoomUnit: 0.01,
    isZoomIn: true,
  },
  zoomOutIncessantly: {
    duration: 15,
    zoomUnit: 0.01,
  },
  zoomToFit: {
    duration: 200,
    isZoomToFit: true,
  },
};
